import api from './axios';

class HubSpotService {
  // Get HubSpot OAuth URL
  async getAuthUrl() {
    try {
      console.log('HubSpot service: Making API call to /hubspot/auth');
      const response = await api.get('/hubspot/auth');
      console.log('HubSpot service: Full API response:', response);
      console.log('HubSpot service: response.data:', response.data);
      console.log('HubSpot service: response.data.authUrl:', response.data.authUrl);
      
      const authUrl = response.data.data.authUrl;
      console.log('HubSpot service: Returning authUrl:', authUrl);
      return authUrl;
    } catch (error) {
      console.error('Error getting HubSpot auth URL:', error);
      throw error;
    }
  }

  // Check HubSpot connection status
  async getConnectionStatus() {
    try {
      const response = await api.get('/hubspot/status');
      return response.data;
    } catch (error) {
      console.error('Error checking HubSpot connection status:', error);
      throw error;
    }
  }

  // Disconnect HubSpot
  async disconnect() {
    try {
      const response = await api.delete('/hubspot/disconnect');
      return response.data;
    } catch (error) {
      console.error('Error disconnecting HubSpot:', error);
      throw error;
    }
  }

  // Get companies from database
  async getCompanies() {
    try {
      const response = await api.get('/company');
      return response.data;
    } catch (error) {
      console.error('Error getting companies:', error);
      throw error;
    }
  }

  // Get contacts from database
  async getContacts(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const url = queryParams ? `/contacts?${queryParams}` : '/contacts';
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error getting contacts:', error);
      throw error;
    }
  }

  // Import contacts from HubSpot
  async importContacts(limit = 100) {
    try {
      const response = await api.get(`/hubspot/import/contacts?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error importing contacts from HubSpot:', error);
      throw error;
    }
  }

  // Import companies from HubSpot
  async importCompanies(limit = 100) {
    try {
      const response = await api.get(`/hubspot/import/companies?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error importing companies from HubSpot:', error);
      throw error;
    }
  }

  // Import deals from HubSpot
  async importDeals(limit = 100) {
    try {
      const response = await api.get(`/hubspot/import/deals?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error importing deals from HubSpot:', error);
      throw error;
    }
  }

  // Log transcript analysis as call activity
  async logCallWithTranscript(transcriptId, contactId = null, companyId = null, logToBoth = false) {
    try {
      const response = await api.post('/hubspot/log-call', {
        transcriptId,
        contactId,
        companyId,
        logToBoth
      });
      return response.data;
    } catch (error) {
      console.error('Error logging call to HubSpot:', error);
      throw error;
    }
  }

  // Build detailed call notes from transcript analysis
  buildDetailedCallNotes(transcript, analysis) {
    let notes = `CALL ANALYSIS REPORT\n\n`;
    
    // Executive Summary
    notes += `EXECUTIVE SUMMARY\n`;
    notes += `${analysis.summary || transcript.summary}\n\n`;
    
    // Call Metrics
    if (analysis.callMetrics) {
      notes += `CALL METRICS\n`;
      notes += `• Duration: ${analysis.callMetrics.duration} minutes\n`;
      notes += `• Participants: ${analysis.callMetrics.participantCount}\n`;
      notes += `• Decision Maker Present: ${analysis.callMetrics.decisionMakerPresent ? 'Yes' : 'No'}\n`;
      notes += `• Urgency Level: ${analysis.callMetrics.urgencyLevel}\n`;
      notes += `• Competitive Mention: ${analysis.callMetrics.competitiveMention ? 'Yes' : 'No'}\n\n`;
    }
    
    // Key Topics
    if (analysis.keyTopics && analysis.keyTopics.length > 0) {
      notes += `KEY TOPICS DISCUSSED\n`;
      analysis.keyTopics.forEach(topic => {
        notes += `• ${topic}\n`;
      });
      notes += `\n`;
    }
    
    // Action Items
    if (analysis.actionItems && analysis.actionItems.length > 0) {
      notes += `ACTION ITEMS\n`;
      analysis.actionItems.forEach(item => {
        notes += `• ${item}\n`;
      });
      notes += `\n`;
    }
    
    // Risk Factors
    if (analysis.riskFactors && analysis.riskFactors.length > 0) {
      notes += `RISK FACTORS\n`;
      analysis.riskFactors.forEach(risk => {
        notes += `• ${risk}\n`;
      });
      notes += `\n`;
    }
    
    // Next Steps
    if (analysis.nextSteps) {
      notes += `NEXT STEPS\n`;
      if (analysis.nextSteps.immediate && analysis.nextSteps.immediate.length > 0) {
        notes += `Immediate:\n`;
        analysis.nextSteps.immediate.forEach(step => {
          notes += `  • ${step}\n`;
        });
      }
      if (analysis.nextSteps.shortTerm && analysis.nextSteps.shortTerm.length > 0) {
        notes += `Short Term:\n`;
        analysis.nextSteps.shortTerm.forEach(step => {
          notes += `  • ${step}\n`;
        });
      }
      if (analysis.nextSteps.longTerm && analysis.nextSteps.longTerm.length > 0) {
        notes += `Long Term:\n`;
        analysis.nextSteps.longTerm.forEach(step => {
          notes += `  • ${step}\n`;
        });
      }
      notes += `\n`;
    }
    
    // Sentiment Analysis
    if (analysis.sentiment) {
      notes += `SENTIMENT ANALYSIS\n`;
      notes += `Overall Sentiment: ${analysis.sentiment}\n`;
      notes += `Confidence: ${analysis.confidence || 'N/A'}\n\n`;
    }
    
    // Strategic Insights
    if (analysis.insights) {
      notes += `STRATEGIC INSIGHTS\n`;
      notes += `${analysis.insights}\n\n`;
    }
    
    notes += `---\n`;
    notes += `Generated by Velox AI on ${new Date().toLocaleString()}`;
    
    return notes;
  }
}

const hubspotService = new HubSpotService();
export default hubspotService; 